import CodeEditor, { CodeEditorProps } from './CodeEditor';

export type { CodeEditorProps };
export default CodeEditor;
